module.exports = __webpack_public_path__ + "static/media/paynow-active.5a220209.svg";